import { Alert, AlertColor, AlertTitle, Box } from "@mui/material";

type Props = {
  handleClose: () => void;
  severity: AlertColor;
  message: string;
  errorCode?: number;
};

function AlertRibbon({ handleClose, severity, message, errorCode }: Props) {
  return (
    <Box
      sx={{
        position: "fixed",
        width: "100vw",
        zIndex: "40",
        marginTop: "80px",
        left: 0,
        top: 0,
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Alert
        onClose={() => handleClose()}
        data-testid="alert-ribbon"
        variant="filled"
        severity={severity}
        style={{ width: "50vw" }}
      >
        <AlertTitle sx={{ textAlign: "start" }}>
          {severity.toUpperCase()}
        </AlertTitle>
        {errorCode
          ? `Request failed with HTTP error code ${errorCode}. ${message}`
          : message}
      </Alert>
    </Box>
  );
}

export default AlertRibbon;
